<template>
  <div>
    <h1>{{ $t("admin.adminPlanCreate.header") }}</h1>
    <form id="search" @submit="checkForm">
      <label for="name">{{ $t("admin.adminPlanCreate.planName") }}: </label
      ><input
        id="name"
        name="name"
        maxlength="30"
        v-model="planData.name"
        v-bind:class="{ error: errPlanName || errSurrogatePair }"
      /><br />
      <label for="groupName"
        >{{ $t("admin.adminPlanCreate.groupName") }}: </label
      ><input id="groupName" name="groupName" v-model="names.group" /><br />
      <label for="projectName"
        >{{ $t("admin.adminPlanCreate.projectName") }}: </label
      ><input
        id="projectName"
        name="projectName"
        v-model="names.project"
      /><br />
      <label for="description"
        >{{ $t("admin.adminPlanCreate.description") }}: </label
      ><textarea
        id="description"
        name="description"
        maxlength="300"
        v-model="planData.description"
        v-bind:class="{ error: errPlanSummary }"
      ></textarea
      ><br />
      <label for="enabled">{{ $t("admin.adminPlanCreate.enabled") }}: </label
      ><input
        id="enabled"
        name="enabled"
        v-model="planData.enabled"
        type="checkbox"
      /><br />
      <label for="planType">{{ $t("admin.adminPlanCreate.planType") }}: </label>
      <select
        id="planType"
        name="planType"
        v-model="planData.planType"
        v-on:change="updateForm = true"
      >
        <option
          v-for="(planType, index) in planTypes"
          v-bind:key="index"
          v-bind:value="planType.value"
          >{{ planType.text }}</option
        >
      </select>
      <br />
      <label for="policy">{{ $t("admin.adminPlanView.policy") }}: </label>
      <select
        id="policy"
        name="policy"
        v-model="planData.policyId"
        v-on:change="updateForm = true"
      >
        <option
          v-for="(policy, index) in selectPolicy"
          v-bind:key="index"
          v-bind:value="policy.policyId"
          >{{ policy.policyName }}</option
        >
      </select>
      <br />
      <label for="maxConcurrentTasks"
        >{{ $t("admin.adminPlanCreate.maxConcurrentTasks") }}: </label
      ><input
        id="maxConcurrentTasks"
        name="maxConcurrentTasks"
        v-model="planData.maxConcurrentTasks"
      /><br />
      <label for="maxPlanMembers"
        >{{ $t("admin.adminPlanCreate.maxPlanMembers") }}: </label
      ><input
        id="maxPlanMembers"
        name="maxPlanMembers"
        v-model="planData.maxPlanMembers"
      /><br />
      <div v-if="userData">
        <label for="owner">{{ $t("admin.adminPlanCreate.owner") }}: </label
        ><input
          id="owner"
          name="owner"
          v-model="userData.name"
          readonly
        /><br />
      </div>
      <div v-if="!userData">
        <label for="userEmailAddress"
          >{{ $t("admin.adminPlanCreate.ownerEmailAddress") }}: </label
        ><input
          id="userEmailAddress"
          name="userEmailAddress"
          v-model="planData.userEmailAddress"
          type="text"
        /><br />
      </div>
      <label for="theme">{{ $t("admin.adminPlanCreate.planTheme") }}: </label>
      <select
        id="theme"
        name="theme"
        v-model="planData.theme"
        v-on:change="updateForm = true"
      >
        <option
          v-for="(theme, index) in planThemes"
          v-bind:key="index"
          v-bind:value="theme.value"
          >{{ theme.text }}</option
        >
      </select>
      <br />
      <label for="mfa">{{ $t("admin.adminPlanCreate.mfa") }}: </label
      ><input
        id="mfa"
        name="mfa"
        v-model="planData.mfa"
        type="checkbox"
      /><br />
      <label for="unlimitedCredit"
        >{{ $t("admin.adminPlanCreate.unlimitedCredit") }}: </label
      ><input
        id="unlimitedCredit"
        name="unlimitedCredit"
        v-model="planData.unlimitedCredit"
        type="checkbox"
      /><br />

      <input
        type="submit"
        class="submit"
        v-bind:value="$t('admin.adminPlanCreate.button.create')"
      />
    </form>
  </div>
</template>

<script>
import { adminService } from "@/services/admin.service";
import { planService } from "@/services/plan.service";
import { groupService } from "@/services/group.service";
import { validSurrogatePair } from "@/utils/validSurrogatePair";
import { validFileInclusion } from "@/utils/validFileInclusion";

export default {
  name: "AdminPlanCreate",
  data: function() {
    return {
      planData: {
        name: "",
        description: "",
        enabled: true,
        planType: 1,
        policyId: 1,
        maxConcurrentTasks: 5,
        maxPlanMembers: 10,
        theme: "",
        unlimitedCredit: false,
      },
      planTypes: [
        {
          text: this.$t("admin.adminPlanView.planTypeSelect.select.item01"),
          value: "1",
        },
        {
          text: this.$t("admin.adminPlanView.planTypeSelect.select.item02"),
          value: "2",
        },
      ],
      planThemes: [
        {
          text: this.$t("admin.adminPlanCreate.planThemeSelect.select.item00"),
          value: null,
        },
        {
          text: this.$t("admin.adminPlanCreate.planThemeSelect.select.item01"),
          value: "sakura",
        },
        {
          text: this.$t("admin.adminPlanCreate.planThemeSelect.select.item02"),
          value: "compass",
        },
        {
          text: this.$t("admin.adminPlanCreate.planThemeSelect.select.item03"),
          value: "coffee",
        },
      ],
      selectPolicy: [],
      names: {
        group: "",
        project: "",
      },
      userData: null,
      invalidForm: true,
      errPlanName: false,
      errSurrogatePair: false,
      errPlanSummary: false,
    };
  },
  created: function() {
    if (this.$route.params.userId) {
      adminService
        .userGet(this.$route.params.userId)
        .then((data) => {
          console.log(data);
          this.planData.appUserId = data.appUserInfo.userId;
          this.userData = {
            name:
              data.appUserInfo.givenName + " " + data.appUserInfo.familyName,
          };
        })
        .catch((err) => {
          console.error("Unable to get user: ", err);
        });
    }
    adminService
      .policySearch(null)
      .then((data) => {
        console.log(data);
        this.selectPolicy = data;
      })
      .catch((err) => {
        console.error("Unable to policy: ", err);
      });
  },
  methods: {
    checkForm: function(event) {
      this.invalidForm = false;
      this.errPlanName = false;
      this.errSurrogatePair = false;
      this.errPlanSummary = false;

      if (
        this.planData.name === "" ||
        this.planData.name.length > 30 ||
        validFileInclusion(this.planData.name)
      ) {
        this.invalidForm = true;
        this.errPlanName = true;
      }

      if (validSurrogatePair(this.planData.name)) {
        this.invalidForm = true;
        this.errSurrogatePair = true;
      }

      if (
        this.planData.description === "" ||
        this.planData.description.length > 300
      ) {
        this.invalidForm = true;
        this.errPlanSummary = true;
      }

      if (!this.invalidForm) {
        this.createPlan();
      }

      event.preventDefault();
    },
    createPlan: function(e) {
      let tmpPlanData = JSON.parse(JSON.stringify(this.planData));
      tmpPlanData.description = btoa(
        encodeURIComponent(this.planData.description)
      );

        adminService
          .planCreate(tmpPlanData)
          .then((plan) => {
            this.createGroup(plan.id);
          })
          .catch((err) => {
            console.error("Unable to create plan: ", err);
          });
    },
    createGroup: function(planId) {
      if (!this.names.group || this.names.group.length == 0) {
        this.$router.push("/admin/planView/" + planId);
      } else {
        let groupInfo = {
          description: btoa(encodeURIComponent(this.planData.name)),
          enabled: true,
          name: this.names.group,
        };

        planService
          .createGroup(planId, groupInfo)
          .then((group) => {
            console.log("Group Created: ", group);
            this.createProject(planId, group.id);
          })
          .catch((err) => {
            console.error("Unable to create group: ", err);
          });
      }
    },

    createProject: function(planId, groupId) {
      if (!this.names.project || this.names.project.length == 0) {
        this.$router.push("/admin/planView/" + planId);
      } else {
        let projectInfo = {
          description: btoa(encodeURIComponent(this.planData.name)),
          enabled: true,
          name: this.names.project,
        };

        groupService
          .createProject(groupId, projectInfo)
          .then((project) => {
            console.log("Project Created: ", project);
            this.$router.push("/admin/planView/" + planId);
          })
          .catch((err) => {
            console.error("Unable to create project: ", err);
          });
      }
    },
  },
};
</script>
